"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineEditRaw = exports.InlineEdit = void 0;
var React = require("react");
var react_1 = require("react");
var hooks_1 = require("@use-ui/hooks");
var classnames_1 = require("classnames");
var validate_1 = require("@use-ui/hooks/dist/validate");
var utils_1 = require("../utils");
exports.InlineEdit = React.memo(InlineEditRaw, function (prev, next) {
    return utils_1.equalExcept(prev, next, "save", "component", "render");
});
function InlineEditRaw(p) {
    var props = __assign({ style: {} }, p);
    var fieldElement = react_1.useRef();
    var _a = react_1.useState(""), edited = _a[0], setEdited = _a[1];
    var _b = react_1.useState(false), editing = _b[0], setEditing = _b[1];
    var _c = react_1.useState(false), saving = _c[0], setSaving = _c[1];
    var _d = react_1.useState(false), saved = _d[0], setSaved = _d[1];
    var _e = react_1.useState(null), error = _e[0], setError = _e[1];
    var progress = saving || props.loading;
    var type = fieldElement.current && hooks_1.getFieldType(fieldElement.current.type || "string");
    function startEditing(e) {
        e && e.preventDefault();
        setEditing(true);
    }
    function save(e) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e && e.preventDefault();
                        setSaving(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, props.save(type.valueToData(edited))];
                    case 2:
                        _a.sent();
                        stopEditing();
                        setSaved(true);
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        setError(e_1.message);
                        return [3 /*break*/, 5];
                    case 4:
                        setSaving(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function cancel(e) {
        e && e.preventDefault();
        setEdited(type.dataToValue(props.value));
        stopEditing();
    }
    function stopEditing() {
        setError(null);
        setEditing(false);
    }
    function tryToSave() {
        if (progress || !editing)
            return;
        if (!updateValidationError()) {
            save();
        }
    }
    function onKeyDown(e) {
        if (e.key == "Enter") {
            e.preventDefault();
            tryToSave();
        }
        if (e.key == "Escape")
            return void cancel(e);
    }
    react_1.useEffect(function () {
        if (fieldElement.current) {
            var type_1 = hooks_1.getFieldType(fieldElement.current.type || "string"); // "render" type could be old here, recreate it
            setEdited(type_1.dataToValue(props.value));
        }
    }, [props.value]);
    react_1.useEffect(function () {
        if (!editing) {
            fieldElement.current.blur();
        }
        else {
            fieldElement.current.focus();
        }
    }, [editing]);
    function renderControls() {
        if (editing) {
            return (React.createElement(React.Fragment, null,
                error ? (React.createElement("a", { className: "error-saving", href: "#", onClick: function (e) { return e.preventDefault(); }, tabIndex: -1 },
                    React.createElement("i", { className: "fa fa-warning" }))) : (React.createElement("a", { className: "save", href: "#", onClick: function (e) { return e.preventDefault(); }, tabIndex: -1 },
                    React.createElement("i", { className: "fa fa-check" }))),
                props.cancel && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "delim" }),
                    React.createElement("a", { className: "cancel", href: "#", onMouseDown: props.disabled ? null : cancel, tabIndex: -1 },
                        React.createElement("i", { className: "fa fa-times cancel" }))))));
        }
        return saved ? (React.createElement("a", { className: "saved", href: "#", onClick: props.disabled ? null : startEditing, tabIndex: -1 },
            React.createElement("i", { className: "fa fa-thumbs-o-up" }))) : (React.createElement("a", { className: "start-edit", href: "#", onClick: props.disabled ? null : startEditing, tabIndex: -1 },
            React.createElement("i", { className: "fa fa-pencil" })));
    }
    function updateValidationError() {
        var error = validate_1.message(fieldElement.current.constraint, edited, validate_1.enValidateMessages);
        setError(error);
        return !!error;
    }
    var field = {
        setFieldElement: function (fe) {
            return (fieldElement.current = fe);
        },
        getValue: function () { return edited; },
        setValue: function (s) {
            setEdited(s);
            if (error)
                updateValidationError();
        },
        onBlur: p.saveOnChange ? undefined : tryToSave,
        onFocus: startEditing,
        getError: function () { return error; },
    };
    react_1.useEffect(function () {
        if (editing && p.saveOnChange)
            tryToSave();
    }, [edited]);
    var fieldProps = {
        field: field,
        label: props.label,
        right: progress ? (React.createElement(Spinner, null)) : (React.createElement("div", { className: classnames_1.default("inline-edit-controls", { disabled: props.disabled }) }, renderControls())),
        disabled: progress || props.disabled,
    };
    return (React.createElement("div", { className: "inline-edit", style: props.style, onKeyDown: onKeyDown }, "component" in props
        ? React.createElement(props.component, fieldProps)
        : props.render(fieldProps)));
}
exports.InlineEditRaw = InlineEditRaw;
var Spinner = function () { return (React.createElement("div", { className: "inline-edit-spinner" },
    React.createElement("div", { className: "lds-spinner", style: { width: "100%", height: "100%" } },
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null)))); };
